export default "__VITE_ASSET__Dxq8ItXb__"